// extracted by mini-css-extract-plugin
export default {"container":"PreviousStepBanner_container__U6IHT","headerWrapper":"PreviousStepBanner_headerWrapper__aUunS","detail":"PreviousStepBanner_detail__Pmsl0"};